import type { TranslationMessages } from '../types';

export const customers: TranslationMessages = {
  name: 'Khách hàng |||| Khách hàng',
  title: 'Khách hàng',
  create: 'Tạo khách hàng',
  edit: 'Chỉnh sửa khách hàng',
  create_description: 'Tạo tài khoản khách hàng mới',
  edit_description: 'Cập nhật thông tin khách hàng',
  fields: {
    firstName: 'Tên',
    lastName: 'Họ',
    email: 'Email',
    phone: 'Số điện thoại',
    address: 'Địa chỉ',
    city: 'Thành phố',
    stateAbbr: 'Tỉnh/Thành',
    zipcode: 'Mã bưu điện',
    birthday: 'Ngày sinh',
    totalSpent: 'Tổng chi tiêu',
    nbCommands: 'Đơn hàng',
    lastSeen: 'Lần cuối',
    orders: 'Đơn hàng',
    first_seen: 'Lần đầu gặp',
    groups: 'Nhóm',
    last_seen: 'Lần cuối gặp',
    last_seen_gte: 'Ghé thăm từ',
    name: 'Tên',
    total_spent: 'Tổng chi tiêu',
    password: 'Mật khẩu',
    confirm_password: 'Xác nhận mật khẩu',
    customerPoints: 'Điểm: %{points}',
    otp: 'Mã OTP',
  },
  filters: {
    last_visited: 'Lần ghé thăm cuối',
    today: 'Hôm nay',
    this_week: 'Tuần này',
    last_week: 'Tuần trước',
    this_month: 'Tháng này',
    last_month: 'Tháng trước',
    earlier: 'Trước đó',
    has_ordered: 'Đã đặt hàng',
    has_newsletter: 'Đăng ký bản tin',
    group: 'Nhóm',
  },
  fieldGroups: {
    identity: 'Thông tin cá nhân',
    address: 'Địa chỉ',
    stats: 'Thống kê',
    history: 'Lịch sử',
    password: 'Mật khẩu',
    change_password: 'Thay đổi mật khẩu',
  },
  page: {
    delete: 'Xóa khách hàng',
    showing: 'Hiển thị',
    to: 'đến',
    of: 'của',
    page: 'Trang',
    customers: 'khách hàng',
  },
  errors: {
    password_mismatch: 'Xác nhận mật khẩu không khớp với mật khẩu.',
  },
  actions: {
    verifyOtp: 'Xác thực OTP',
  },
};
